import React from "react";
import { Typography, Card, Tooltip, Button } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import CheckIcon from "@material-ui/icons/Check";
import CreateIcon from "@material-ui/icons/Create";
import { MedalTableIcon } from "@icarius-icons/index";
import _ from "@lodash";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const CARD_HEIGHT = 350;
const IMAGE_HEIGHT = 125;

const PollItem = (props) => {
    const { name, image, text, points, isCompleted, onClick } = props;

    const color = useSelector(getAppColor);

    return (
        <Card
            style={{
                margin: 5,
                height: CARD_HEIGHT,
                borderRadius: 15,
                backgroundColor: "var(--secondaryBackgroundColor)",
            }}
        >
            <div className={"item-container"} style={{ cursor: "cursor" }} onClick={onClick}>
                <div
                    className={"image-container"}
                    style={{
                        backgroundImage: "url('" + image + "')",
                        backgroundSize: "cover",
                        height: `${IMAGE_HEIGHT}px`,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                    >
                        <Typography
                            variant="caption"
                            style={{
                                color: "white",
                                cursor: "pointer",
                                textDecoration: "underline",
                                textAlign: "center",
                                wordBreak: "break-word",
                                maxWidth: "80%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            {isCompleted ? (
                                <CheckIcon className={"download-icon"} />
                            ) : (
                                <CreateIcon className={"download-icon"} />
                            )}
                            {isCompleted ? getLocalizedString("pollAnswered") : getLocalizedString("giveOpinion")}
                        </Typography>
                    </div>
                </div>
                <div
                    style={{
                        height: `calc(${CARD_HEIGHT}px - ${IMAGE_HEIGHT}px - 40px)`,
                        margin: "20px",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        gap: 15,
                    }}
                >
                    <Typography className={"item-name"}>{name}</Typography>
                    <Tooltip title={text} arrow>
                        <Typography className="whiteText" style={{ fontSize: 16, fontWeight: 500 }} align="center">
                            {_.truncate(text.replace(/<(?:.|\n)*?>/gm, ""), { length: 70 })}
                        </Typography>
                    </Tooltip>
                    <Button
                        variant="contained"
                        className="whiteText"
                        style={{
                            marginTop: 20,
                            border: 0,
                            backgroundColor: isCompleted ? "var(--tertiaryBackgroundColor)" : color,
                            borderRadius: 24,
                        }}
                    >
                        {getLocalizedString(isCompleted ? "viewAnswers" : "answerPoll")}
                    </Button>
                    {Boolean(points) && (
                        <Tooltip arrow title={getLocalizedString("pollMedalTablePoints", { points: points })}>
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: -15,
                                    left: "calc(50% - 15px)",
                                }}
                            >
                                <MedalTableIcon style={{ fill: "var(--mainText)" }} />
                            </div>
                        </Tooltip>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default PollItem;
